import React from 'react';
import PropTypes from 'prop-types';
import { Col } from 'react-bootstrap';
import styles from './styles.css';

/*
Added a copy of DetailsPanel with only the md size as a difference since passing mdSize as a prop was not working
for some reason
 */
const LongDetailsPanel = ({ children, title }) => (
  <Col xs={12} md={12}>
    {title && <h4 className={styles.title}>{title}</h4>}
    { children }
  </Col>
);

LongDetailsPanel.propTypes = {
  children: PropTypes.any,
  title: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
};

LongDetailsPanel.defaultProps = {
  children: null,
  title: null,
};

export default LongDetailsPanel;



// WEBPACK FOOTER //
// ./src/components/LongDetailsPanel/index.js